export default function TechHub() {
    return <>
        Tech hub
        <br/>
        Tech tools for managing tech related features will go here, EG managing broken matches
    </>
}
